import React from "react";
import Burge1 from "./Burge1";
import Burger2 from "./Burger2";
import Burger3 from "./Burger3";

const Burger = () => {
  return (
    <div>
      <Burge1></Burge1>
      <Burger2></Burger2>
      <Burger3></Burger3>
    </div>
  );
};

export default Burger;
